import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { MetricDefinition } from '../types';
import { Formula } from './Formula';

const MetricContainer = styled.div`
  margin-bottom: ${spacing.double};
`;

const Label = styled.h4`
  font-weight: bold;
`;

export const MetricCard = ({ metric }: { metric: MetricDefinition }) => {
  const [codeView, setCodeView] = useState(false);

  useEffect(() => {
    const onKeyDown = (e: any) => {
      if (e.key === 'Enter') {
        setCodeView(!codeView);
      }
    };
    window.addEventListener('keydown', onKeyDown);

    return () => window.removeEventListener('keydown', onKeyDown);
  }, [codeView]);

  return (
    <MetricContainer>
      <Label>{metric?.label}</Label>
      {metric?.description && <p>{metric.description}</p>}
      {metric?.numerator && (
        <Formula
          numerator={metric.numerator}
          denominator={metric.denominator}
          variant={'tooltip'}
          codeView={codeView}
        />
      )}
    </MetricContainer>
  );
};
